/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCurrentUser200ResponseAllOfData } from './GetCurrentUser200ResponseAllOfData';
import {
    GetCurrentUser200ResponseAllOfDataFromJSON,
    GetCurrentUser200ResponseAllOfDataFromJSONTyped,
    GetCurrentUser200ResponseAllOfDataToJSON,
} from './GetCurrentUser200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCurrentUser200Response
 */
export interface GetCurrentUser200Response {
    /**
     * 
     * @type {GetCurrentUser200ResponseAllOfData}
     * @memberof GetCurrentUser200Response
     */
    data: GetCurrentUser200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetCurrentUser200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetCurrentUser200Response interface.
 */
export function instanceOfGetCurrentUser200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetCurrentUser200ResponseFromJSON(json: any): GetCurrentUser200Response {
    return GetCurrentUser200ResponseFromJSONTyped(json, false);
}

export function GetCurrentUser200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCurrentUser200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCurrentUser200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetCurrentUser200ResponseToJSON(value?: GetCurrentUser200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCurrentUser200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

